'use client';

import { ReactNode, createContext } from 'react';

export type PageContextValue = {
    pageName: string | null;
    route: string | null;
    params: Record<string, string>;
};

export const PageContext = createContext<PageContextValue>({
    pageName: null,
    route: null,
    params: {},
});

type Props = PageContextValue & {
    children?: ReactNode;
};

export const PageProvider = ({ pageName, route, params, children }: Props) => {
    return (
        <PageContext.Provider value={{ pageName, route, params }}>
            <div
                className="page"
                data-testid="page"
                data-page={pageName}
                data-route={route}
                data-params={JSON.stringify(params)}
            >
                {children}
            </div>
        </PageContext.Provider>
    );
};
